import { c as _c } from "react/compiler-runtime";
import { useCursorPagination } from '@/hooks/useCursorPagination';
import { orpc } from '@/lib/orpc/client';
import { errorCodeOf } from '@/lib/orpc/errors';
import { NO_HOLDERS, toCursorPage, type VaultHoldersQueryInput, vaultHoldersQueryKey } from '../vaultHoldersQuery';

/** Cursor-paginated holders of a vault, shared by the V1 and V2 distribution tables. */
export const useVaultHoldersData = input => {
  const $ = _c(9);
  let t0;
  if ($[0] !== input) {
    t0 = vaultHoldersQueryKey(input);
    $[0] = input;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] !== input) {
    t1 = async cursor => {
      ;
      try {
        return toCursorPage(await orpc.vault.holders.call({
          ...input,
          cursor
        }));
      } catch (t3) {
        const error = t3;
        if (cursor === undefined && errorCodeOf(error) === "NOT_FOUND") {
          return toCursorPage(NO_HOLDERS);
        }
        throw error;
      }
    };
    t2 = JSON.stringify(input);
    $[2] = input;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      resetKey: t2,
      trustCursorOnEmptyPage: true
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useCursorPagination(t3);
};